export default __webpack_public_path__ + "db80e53f19497264ad3aea4f86811056.png";